import { CheckCircle2, FileText, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import useRiskScan from '../../hooks/useRiskScan';

export default function AdvisoryReportTile() {
  const { t } = useTranslation();

  const { hasAdvisoryReport, isAdvisoryReportLoading } = useRiskScan();

  if (isAdvisoryReportLoading) {
    return (
      <div className="flex flex-col gap-1 rounded-lg bg-neutral-100 p-2 text-sm dark:bg-neutral-900/40">
        <div className="flex items-center gap-1 font-bold text-neutral-800 dark:text-neutral-200">
          {t('ADVISORY_REPORT')}
        </div>

        <div className="">
          <span className="flex items-center gap-1 text-xs text-neutral-800 dark:text-neutral-200">
            <Loader2 className="size-4 animate-spin" />
            {t('LOADING')}
          </span>
        </div>
      </div>
    );
  }

  if (hasAdvisoryReport) {
    return (
      <div className="flex flex-col gap-1 rounded-lg bg-green-100 p-2 text-sm dark:bg-green-900/40">
        <div className="flex items-center gap-1 font-bold text-green-800 dark:text-green-200">
          {t('ADVISORY_REPORT')}
        </div>

        <div className="">
          <span className="flex items-center gap-1 text-xs text-green-800 dark:text-green-200">
            <CheckCircle2 className="size-4" />
            {t('STATUS_AVAILABLE')}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1 rounded-lg bg-neutral-100 p-2 text-sm dark:bg-neutral-900/40">
      <div className="flex items-center gap-1 font-bold text-neutral-800 dark:text-neutral-200">
        {t('ADVISORY_REPORT')}
      </div>

      <div className="">
        <span className="flex items-center gap-1 text-xs text-neutral-800 dark:text-neutral-200">
          <FileText className="size-4" />

          {t('STATUS_DRAFTING')}
        </span>
      </div>
    </div>
  );
}
